import React from 'react'

type NavIconId = 0 | 1 | 2 | 3 | 4

const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true as const,
  focusable: false as const,
}

function HomeIcon() {
  return (
    <svg {...svgProps}>
      <path
        d="M4.5 10.8 12 4.5l7.5 6.3V19a1.5 1.5 0 0 1-1.5 1.5h-3.75V14.25h-4.5V20.5H6A1.5 1.5 0 0 1 4.5 19v-8.2Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
        fill="currentColor"
        fillOpacity="0.18"
      />
    </svg>
  )
}

function DepositIcon() {
  return (
    <svg {...svgProps}>
      <rect
        x="4.5"
        y="7"
        width="15"
        height="12"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <path
        d="M12 4.2v8.2M9.1 9.4 12 12.3l2.9-2.9"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="16.6" cy="14.8" r="1.15" fill="currentColor" />
    </svg>
  )
}

function DashboardIcon() {
  return (
    <svg {...svgProps}>
      <rect
        x="3.5"
        y="3.5"
        width="7.5"
        height="7.5"
        rx="1.8"
        stroke="currentColor"
        strokeWidth="1.7"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <rect
        x="13"
        y="3.5"
        width="7.5"
        height="4.5"
        rx="1.6"
        stroke="currentColor"
        strokeWidth="1.7"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <rect
        x="13"
        y="10.5"
        width="7.5"
        height="10"
        rx="1.8"
        stroke="currentColor"
        strokeWidth="1.7"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <rect
        x="3.5"
        y="13.5"
        width="7.5"
        height="7"
        rx="1.8"
        stroke="currentColor"
        strokeWidth="1.7"
        fill="currentColor"
        fillOpacity="0.16"
      />
    </svg>
  )
}

function WithdrawIcon() {
  return (
    <svg {...svgProps}>
      <rect
        x="4.5"
        y="5"
        width="15"
        height="12"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <path
        d="M12 19.8v-8.2M9.1 14.6 12 11.7l2.9 2.9"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="16.6" cy="10.2" r="1.15" fill="currentColor" />
    </svg>
  )
}

function PromoIcon() {
  return (
    <svg {...svgProps}>
      <path
        d="M8.2 20.2 4.8 16.8a2.2 2.2 0 0 1 0-3.1l8.5-8.5a2.2 2.2 0 0 1 3.1 0L19.8 8a2.2 2.2 0 0 1 0 3.1l-8.5 8.5a2.2 2.2 0 0 1-3.1 0Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <circle cx="15.35" cy="8.65" r="1.25" fill="currentColor" />
      <path
        d="M8.8 14.2h3.4M10 15.8v-3.4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

const ICONS: Record<NavIconId, React.FC> = {
  0: HomeIcon,
  1: DepositIcon,
  2: DashboardIcon,
  3: WithdrawIcon,
  4: PromoIcon,
}

export function HtdBottomNavIcon({ id }: { id: number }) {
  const Icon = ICONS[id as NavIconId] ?? HomeIcon
  return (
    <span className="htd-nav-svg" data-nav-id={id}>
      <Icon />
    </span>
  )
}
